export default __webpack_public_path__ + "static/media/mixergy.f7d07215.png";